import { PaymentMethodType } from './autopay';
import { FeeCalculationType } from './feeCalculationType';
import { SourcePayRazrApplication } from './sourcePayRazrApplication';

export class FeeCalculationValue {
	sourcePayRazrApplication: SourcePayRazrApplication;
	feePaymentMethodType: PaymentMethodType;
	feeValue: number;
	feeCalculationType: FeeCalculationType;
	tierLimitKey: number;
	tierLimitAmount: number;
}
